import { SOFTPHONES_KEY, VALIDATING_TELEPHONY, SM_QUEUE_SERVER } from '../../constants.js';
import { messageFirstCall, messageHangUp } from '../../js/helpers/helperMessages';
import { HANG_UP_SUBACTIONS } from '../../constants.js';
import { Logger } from '../helpers/Logger.js';

export const SOFTPHONE_CALLBACKS = {
	[SOFTPHONES_KEY.WEBRTC]: that => {
		Logger.Trace('[Strategies_SoftPhone][SOFTPHONE_CALLBACKS] SIP method');
		let _that = that;
		that.agentController.AgentObject.onSipAccepted = () => {
			Logger.Trace('[Strategies_SoftPhone][SOFTPHONE_CALLBACKS] SIP Accepted');
			if (!_that.sharedData.getLogged()) {
				_that.props.validatingState(VALIDATING_TELEPHONY.VALIDATING, _that.telephonyTime);
				_that.sendToRabbit(SM_QUEUE_SERVER, messageFirstCall(_that.sharedData.getUserData().Login, _that.sharedData.getParameters().UserID));
				let sipID = 'sip:' + _that.sharedData.getParameters().Extension + '|' + _that.sharedData.getParameters().UserID + '|0';
				setTimeout(() => {
					_that.makeCall(sipID);
				}, 500);
			}
		};
		that.agentController.AgentObject.onSipRejected = () => {
			Logger.Trace('[Strategies_SoftPhone][SOFTPHONE_CALLBACKS] SIP Rejected');
		};
		that.agentController.AgentObject.onCallEntry = () => {
			Logger.Trace('[Strategies_SoftPhone][SOFTPHONE_CALLBACKS] Incoming Call');
		};
		that.agentController.AgentObject.uiCallTerminated = () => {
			Logger.Trace('[Strategies_SoftPhone][SOFTPHONE_CALLBACKS] Call Finished');
		};
		that.agentController.AgentObject.onCallAnswered = () => {
			Logger.Trace('[Strategies_SoftPhone][SOFTPHONE_CALLBACKS] Call Answered');
		};
		that.agentController.AgentObject.onCallRejected = () => {
			Logger.Trace('[Strategies_SoftPhone][SOFTPHONE_CALLBACKS] Call Rejected');
		};
		that.agentController.AgentObject.onTransportDisconnected = function (parameter) {
			Logger.Warn('TRANSPORT DISCONNECTED REASON:', parameter);
			if (that.rabbitConnected) {
				if (parameter.attempt < 50) {
					that.props.showAlertModal({
						type: 'ModalAlert',
						title: that.language.getText('GUIErrorMessagetitle'),
						message: that.language.getText('error-8001') + ' ' + parameter.attempt,
						button: that.language.getText('GUIErrorMessageclose')
					});
				} else {
					that.props.showAlertModal({
						type: 'ModalError',
						title: that.language.getText('GUIErrorMessagetitle'),
						message: that.language.getText('error-1'),
						button: that.language.getText('GUITelephonyValidatorreconnect'),
						secondButtonFtn: () => {},
						buttonFun: () => {
							that.logOut();
						}
					});
				}
			}
		};
		that.agentController.AgentObject.onTransportConnected = function () {
			if (that.rabbitConnected) {
				Logger.Info('TRANSPORT CONNECTED');
				that.props.hideAlertModal();
			}
		};
		that.agentController.AgentObject.onDataStreamInfo = (streamLevel, message) => {
			if (streamLevel > 1) {
				Logger.Warn('[Strategies_SoftPhone][SOFTPHONE_CALLBACKS][Stream_Information]', message);
			}
			that.props.streamFromSip(streamLevel);
		};

		that.agentController.AgentObject.onChangeDeviceList = audioList => {
			Logger.Warn('onChangeDeviceList', audioList);
			for (var i in audioList) {
				let device = audioList[i];
				let [direction] = device.kind.match(/(\w+)(input|output)/i);
				if (direction === 'audio') {
					console.log('onChangeDeviceList', { label: device.label, direction: direction });
				}
			}
		};

		that.agentController.AgentObject.onGetStreamMicFail = () => {
			Logger.Warn('[Strategies_SoftPhone][SOFTPHONE_CALLBACKS] onGetStreamMicFail');
			that.props.showAlertModal({
				type: 'ModalError',
				title: that.language.getText('GUIErrorMessagetitle'),
				message: that.language.getText('error-8002'),
				button: that.language.getText('GUIErrorMessageclose'),
				secondButtonFtn: () => {},
				buttonFun: () => {}
			});
		};
	},
	[SOFTPHONES_KEY.MIZUJS]: () => {
		Logger.Trace('[Strategies_SoftPhone][SOFTPHONE_CALLBACKS] Mizu method');
	}
};

export const SOFTPHONE_VALIDATING = {
	[SOFTPHONES_KEY.WEBRTC]: () => {
		Logger.Trace('[Strategies_SoftPhone][SOFTPHONE_VALIDATING] SIP method');
	},
	[SOFTPHONES_KEY.MIZUJS]: that => {
		Logger.Trace('[Strategies_SoftPhone][SOFTPHONE_VALIDATING] Mizu method');
		that.props.validatingState(VALIDATING_TELEPHONY.VALIDATING, that.telephonyTime);
		that.sendToRabbit(SM_QUEUE_SERVER, messageFirstCall(that.sharedData.getUserData().Login, that.sharedData.getParameters().UserID));
	}
};

export const SOFTPHONE_MAKECALL = {
	[SOFTPHONES_KEY.WEBRTC]: (that, message, userID) => {
		that.parametersEngine();
		that.setIpEngine(message.EngineId, that.Engines[message.EngineId]);
		let sipID = 'sip:' + that.sharedData.getParameters().Extension + '|' + userID + '|' + message.CallId;
		let _that = that;
		Logger.Trace('SIP-URI updated:' + sipID);
		setTimeout(() => {
			_that.makeCall(sipID);
		}, 200);
	},
	[SOFTPHONES_KEY.MIZUJS]: () => {}
};

export const SOFTPHONE_PARAMETERS = {
	[SOFTPHONES_KEY.WEBRTC]: that => {
		Logger.Trace('[STRATEGIES_SOFTPHONE][WEB_RTC] Reading setting 183 for WebRTC Configuration');
		let SipParameters = that.sharedData.getGeneralPermissions()[183];
		Logger.Debug('[STRATEGIES_SOFTPHONE][WEB_RTC] WebRTC configuration: ', SipParameters);
		var settingSIP = SipParameters.split('|');

		Logger.Trace('[STRATEGIES_SOFTPHONE][WEB_RTC] Reading setting 143 for Engine Position');
		let setting143 = that.sharedData.getGeneralPermissions()[143];
		Logger.Debug('[STRATEGIES_SOFTPHONE][WEB_RTC] Engine Position: ', setting143);
		if(!setting143){
			Logger.Warn('[STRATEGIES_SOFTPHONE][WEB_RTC] Not Config: ', setting143);
		}

		let ipKamailio = setting143.split('|');
		
		ipKamailio = ipKamailio[1].split(',');
		let stunServers = settingSIP[6].replace(/\\/g, '');
		try {
			stunServers = JSON.parse(stunServers);
		} catch (e) {
			Logger.Error('[STRATEGIES_SOFTPHONE][WEB_RTC] invalid stun server', e);
		}
		that.agentController.AgentObject.SIP_wsServers = [settingSIP[1]];
		that.agentController.AgentObject.SIP_authorizationUser = settingSIP[2].replaceAll('#UserIP#', that.sharedData.getIPfromAPI());
		that.agentController.AgentObject.SIP_uri = settingSIP[3].replaceAll('#UserIP#', that.sharedData.getIPfromAPI());
		that.agentController.AgentObject.SIP_password = settingSIP[4];
		that.agentController.AgentObject.SIP_userAgentString = 'Nuxiba-WebRTC';
		that.agentController.AgentObject.SIP_stunServers = stunServers;
		that.agentController.AgentObject.SIP_register = false;
		that.agentController.AgentObject.SIP_iceCheckingTimeout = 750;
		that.agentController.setUserId(Logger.getUserID());
		that.setIpEngine(0, ipKamailio[0]);
	},
	[SOFTPHONES_KEY.MIZUJS]: (that, parameterMizu) => {
		let MizuParameters = that.sharedData.getGeneralPermissions()[131];
		let encrpytionMode = parseInt(that.sharedData.getGeneralPermissions()[132], 10);
		let primaryServer = that.sharedData.getGeneralPermissions()[133];
		let secondaryServer = that.sharedData.getGeneralPermissions()[134];

		var encryptionServer = '';
		var useEncryption = true;
		switch (encrpytionMode) {
			case 1:
				encryptionServer = primaryServer;
				break;
			case 2:
				encryptionServer = secondaryServer;
				break;
			case 3:
				encryptionServer = Math.random() > 0.5 ? primaryServer : secondaryServer;
				break;
			default:
				encryptionServer = '';
				useEncryption = false;
				break;
		}

		let arrayMizuParameters = MizuParameters.split('|');
		var mizuCodecPriority = parseInt(arrayMizuParameters[0], 10);
		var mizuUseStun = arrayMizuParameters[1];
		var mizuUseRport = arrayMizuParameters[2];
		var mizuLogLevel = parseInt(arrayMizuParameters[3], 10);
		var mizuVolumeSpeaker = parseInt(arrayMizuParameters[4], 10);
		var mizuVolumePlayback = parseInt(arrayMizuParameters[5], 10);
		Logger.Info('[Strategies_Softphone] mizuVolumeSpeaker', mizuVolumeSpeaker);
		Logger.Info('[Strategies_Softphone] mizuVolumePlayback', mizuVolumePlayback);
		var mizuDtmfMode = arrayMizuParameters[6];

		mizuVolumePlayback = mizuVolumePlayback > 100 ? 100 : mizuVolumePlayback <= 0 ? 50 : mizuVolumePlayback;
		mizuLogLevel = mizuLogLevel === 0 ? 1 : mizuLogLevel;

		var prefCodec = 'pcmu';

		var mizuUseG711u = 2;
		var mizuUseG711a = 2;
		var mizuUseG729 = 2;

		switch (mizuCodecPriority) {
			case 1:
				prefCodec = 'pcmu';
				mizuUseG711u = 3;
				break;
			case 2:
				prefCodec = 'pcma';
				mizuUseG711a = 3;
				break;
			case 3:
				prefCodec = 'g729';
				mizuUseG729 = 3;
				break;
			default:
				break;
		}

		let remote = 0;

		let parameters = {
			serveraddress: '127.0.0.1',
			localip: that.sharedData.getParameters().ClientComp,
			username: 'Centerware',
			password: 'passwordless',
			realm: 'asterisk',
			register: '0', //0,1,2
			autoaccept: 'true',
			automute: '0',
			dtmfmode: mizuDtmfMode,
			signalingport: '5060',
			rtpport: '49000',
			ringtone: mizuVolumeSpeaker,
			volumein: mizuVolumeSpeaker,
			volumeout: mizuVolumePlayback,
			loglevel: mizuLogLevel,
			logtoconsole: mizuLogLevel === 5,
			prefcodec: prefCodec,
			checkvolumesettings: 2,
			video: 0,
			vad: 1,
			resetsettings: true,
			aec: 0,
			aec2: 0,
			agc: 0,
			denoise: 0,
            codec: '"' + prefCodec + '",use_pcmu=' + mizuUseG711u + ',use_pcma=' + mizuUseG711a + ',use_g729=' + mizuUseG729,
            beeponconnect: 0,
            beeponincoming: 0,
            ringincall: 0
		};

		if (remote === 1) {
			parameters.use_rport = mizuUseRport;
			parameters.use_fast_stun = mizuUseStun;
			if (useEncryption) {
				parameters.serveraddress = encryptionServer;
				parameters.autotransportdetect = true;
			}
		}

		if (parameterMizu) {
			Logger.Trace('[Strategies_SoftPhone][SOFTPHONE_PARAMETERS] Parameters to MIZU manifest.json => ', parameterMizu);
			for (var i in parameterMizu) {
				parameters[i] = parameterMizu[i];
			}
		}

		Logger.Debug('[Strategies_SoftPhone][SOFTPHONE_PARAMETERS] Parameters to MIZU => ', parameters);
		that.agentController.sipController.setParametersSofPhone(parameters);
	}
};
export const SOFTPHONE_HANGUP = {
	[SOFTPHONES_KEY.WEBRTC]: that => {
		Logger.Trace('[Strategies_SoftPhone][SOFTPHONE_HANGUP] Hangup WEBRTC');
		that.agentController.hangUp();
	},
	[SOFTPHONES_KEY.MIZUJS]: that => {
		Logger.Trace('[Strategies_SoftPhone][SOFTPHONE_HANGUP] Hangup MIZU');
		that.sendToRabbit(SM_QUEUE_SERVER, messageHangUp(HANG_UP_SUBACTIONS.FISRT_CALL,0));
	}
};



// WEBPACK FOOTER //
// ./src/js/Strategies/Strategies_SoftPhone.js